 let schedulingTypes = [
    {
        id: 0,
        label: "默认"   
    },
    {
        id: 1,
        label: "学习班"   
    },
    {
        id: 2,
        label: "单位课程"   
    },
    {
        id: 3,
        label: "党组织生活"   
    },
]

function transferSchedulingType(type:any){
    for(let i = 0 ; i < schedulingTypes.length; i++){
        if(schedulingTypes[i].id == type){
            return schedulingTypes[i].label;
        }
    }

    return "未定义"
}


let gpsLevels = [
    {
        id: 0,
        label: "普通"   
    },
    {
        id: 1,
        label: "小"   
    },
    {
        id: 2,
        label: "大"   
    },
    {
        id: 3,
        label: "超大"   
    },
]

function transferGPSLevel(type:any){
    for(let i = 0 ; i < gpsLevels.length; i++){
        if(gpsLevels[i].id == type){
            return gpsLevels[i].label;
        }
    }

    return "未定义"
}

let showLevels = [
    {
        id: 0,
        label: "全部"   
    },
    {
        id: 1,
        label: "指定单位"   
    },
    {
        id: 2,
        label: "指定支部"   
    },
    {
        id: 3,
        label: "指定个人"   
    },
]

function transferShowLevels(type:any){
    for(let i = 0 ; i < showLevels.length; i++){
        if(showLevels[i].id == type){
            return showLevels[i].label;
        }
    }

    return "未定义"
}
 
 
export {
    schedulingTypes,
    transferSchedulingType,
    gpsLevels,
    transferGPSLevel,
    showLevels,
    transferShowLevels
}